import { Route, Routes } from 'react-router-dom';
import Home from './components/pages/Home/Home';
import Offers from './components/pages/Offers/Offers';
import AboutUsPage from './components/pages/AboutUsPage/AboutUsPage';
import Layout from './components/layout/layout';
import Team from './components/pages/Team/Team';
import PriceList from './components/pages/PriceList/PriceList';
import ContactPage from './components/pages/ContactPage/ContactPage';
import { ScrollToTop } from './components/specialFunction/ScrtollToTop';
import Articles from './components/pages/Articles/Articles';
import ArticleDetails from './components/pages/ArticlesDetails/ArticleDetails';

function App() {
  return (
    <div>
      <Layout>
        <ScrollToTop />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/offers' element={<Offers />} />
          <Route path='/aboutUs' element={<AboutUsPage />} />
          <Route path='/team' element={<Team />} />
          <Route path='/priceList' element={<PriceList />} />
          <Route path='/articles' element={<Articles />} />
          <Route path='/article/:id' element={<ArticleDetails />} />
          <Route path='/contact' element={<ContactPage />} />
        </Routes>
      </Layout>
    </div>
  );
}

export default App;
